import { AgentMinerSessionDetail } from '../../../api/agent-miner-client/agent-miner-client.type';
import {
  inkDarkest,
  primaryBase,
  redBase,
  secondaryBase,
  secondaryDarkest,
  secondaryLighter,
  skyDark,
} from '../../../styles/design-tokens';

type SessionTraceStripProps = {
  session: AgentMinerSessionDetail;
};

const EVENT_TYPE_COLOR: Record<string, string> = {
  USER_MESSAGE: inkDarkest,
  MESSAGE: inkDarkest,
  RESPONSE: secondaryBase,
  ASSISTANT_MESSAGE: secondaryBase,
  THINKING: secondaryLighter,
  PLANNING: secondaryLighter,
  TOOL_CALL: skyDark,
  TOOL_RESULT: primaryBase,
  TOOL_ERROR: redBase,
  ERROR: redBase,
  SUBAGENT_START: secondaryDarkest,
  SUBAGENT_SPAWN: secondaryDarkest,
  SUBAGENT_STOP: secondaryDarkest,
  SUBAGENT_ERROR: redBase,
  TODO_CREATED: secondaryLighter,
  TODO_COMPLETED: secondaryLighter,
};

// Higher number wins when multiple events share a bucket — errors must always
// remain visible, while frequent tool calls shouldn't drown out a single
// user/assistant turn.
const EVENT_TYPE_PRIORITY: Record<string, number> = {
  TOOL_ERROR: 6,
  ERROR: 6,
  SUBAGENT_ERROR: 6,
  USER_MESSAGE: 5,
  MESSAGE: 5,
  SUBAGENT_START: 5,
  SUBAGENT_SPAWN: 5,
  RESPONSE: 4,
  ASSISTANT_MESSAGE: 4,
  SUBAGENT_STOP: 4,
  TOOL_RESULT: 3,
  THINKING: 2,
  PLANNING: 2,
  TODO_CREATED: 2,
  TODO_COMPLETED: 2,
  TOOL_CALL: 1,
};

const MAX_TICKS = 300;

type TraceTick = {
  id: string;
  key: string;
  count: number;
};

export { EVENT_TYPE_COLOR, EVENT_TYPE_PRIORITY, MAX_TICKS };
export type { SessionTraceStripProps, TraceTick };
